import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef} from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getUnits, stripHTML, setConfig, getConfig, getYesNo } from "../../utils"
import cloneDeep from 'lodash/cloneDeep';


const ExpenseVatAdmin = () => {

    let navigate = useNavigate();
    const { expenseVatStore}= useStores();   
    const { expenseVats, remove, duplicate, getAllWithOptions/*, setConfig, config*/ } = expenseVatStore;
    const { t, i18n } = useTranslation();
    
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);

    const onPageChange = (props) => {        
        var newProps = cloneDeep(props);       
        setIsLoading(true);
        getAllWithOptions(newProps).then(() => {
            setIsLoading(false);
        });
    }

    return (
        <ManagementTable name={t('expenseVats')} ref={tableRef} isLoading={isLoading}
            config={{
                size: getConfig("expenseVats", "size"),
                dataState: getConfig("expenseVats", "dataState")
            }}
            onColumnSizeChange={(c) => setConfig("expenseVats", "size", c)}
            onDataStateChange={(c) => { setConfig("expenseVats", "dataState", c) }}

            items={expenseVats?.results} onPageChange={onPageChange} pageCount={expenseVats?.pageCount} total={expenseVats?.count} pageSize={expenseVats?.pageSize} columns={
                [                    
                    { name: "tax", fn: (v) => `${v} %`, filter: "numeric", useFormat: { decimals: 2 } },
                    { name: "winbizCode" },                    
                ]}
            extraButtons={
                [
                    { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },                    
                    { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                ]
            }
             />
    );   
};

export default observer(ExpenseVatAdmin);
